import { MapPin, Phone, Clock, Car, Navigation } from "lucide-react";

const LocationsSection = () => {
  const locations = [
    {
      name: "Gymtots Hamble",
      address: "Hamble Sports Complex",
      postcode: "SO31 4NE",
      phone: "02380 455007",
      hours: "Mon-Fri: 9am-4pm, Sat: 9am-12pm",
      parking: "Free parking available",
      nearby: "Near Hamble village centre",
      mapUrl: "https://maps.google.com/?q=SO31+4NE"
    },
    {
      name: "Gymtots West End",
      address: "West End Parish Centre",
      postcode: "SO30 3FE",
      phone: "02380 455007",
      hours: "Mon-Fri: 9am-4pm, Sat: 9am-12pm",
      parking: "Free parking available",
      nearby: "West End, Southampton",
      mapUrl: "https://maps.google.com/?q=SO30+3FE"
    }
  ];

  return (
    <section className="py-10 md:py-14 bg-white" id="locations">
      <div className="container-gymtots">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2D3436] mb-2" style={{ fontFamily: 'Fredoka, cursive' }}>
            Find <span className="text-[#ff3131]">Us</span>
          </h2>
          <p className="text-[#636E72] text-sm">Two convenient locations across Southampton</p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {locations.map((loc, i) => (
            <div key={i} className="bg-[#FFFBF5] rounded-2xl p-5 border border-gray-100">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-xl bg-[#7dbff8]/20 flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-[#7dbff8]" />
                </div>
                <h3 className="text-lg font-bold text-[#2D3436]" style={{ fontFamily: 'Fredoka, cursive' }}>
                  {loc.name}
                </h3>
              </div>

              <div className="space-y-3 text-sm">
                <div className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 text-[#636E72] mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="text-[#2D3436] font-medium">{loc.address}</p>
                    <p className="text-[#636E72]">{loc.postcode}</p>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <Phone className="w-4 h-4 text-[#636E72] flex-shrink-0" />
                  <a href={`tel:${loc.phone.replace(/\s/g, '')}`} className="text-[#ff3131] font-medium hover:underline">
                    {loc.phone}
                  </a>
                </div>

                <div className="flex items-start gap-2">
                  <Clock className="w-4 h-4 text-[#636E72] mt-0.5 flex-shrink-0" />
                  <p className="text-[#636E72]">{loc.hours}</p>
                </div>

                <div className="flex items-start gap-2">
                  <Car className="w-4 h-4 text-[#636E72] mt-0.5 flex-shrink-0" />
                  <p className="text-[#636E72]">{loc.parking}</p>
                </div>

                <div className="flex items-start gap-2">
                  <Navigation className="w-4 h-4 text-[#636E72] mt-0.5 flex-shrink-0" />
                  <p className="text-[#636E72]">{loc.nearby}</p>
                </div>
              </div>

              <a 
                href={loc.mapUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 w-full bg-[#7dbff8] hover:bg-[#6ca6d9] text-white text-center py-2.5 rounded-full text-sm font-bold block transition-colors"
                style={{ fontFamily: 'Fredoka, cursive' }}
              >
                Get Directions
              </a>
            </div>
          ))}
        </div>

        {/* Contact Banner */}
        <div className="mt-8 bg-gradient-to-r from-[#ff3131] to-[#ff6b6b] rounded-2xl p-5 md:p-6 text-white text-center">
          <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Fredoka, cursive' }}>
            Still have questions?
          </h3>
          <p className="text-white/90 text-sm mb-4">
            Call us or email us - we'd love to hear from you!
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a 
              href="tel:02380455007"
              className="bg-white text-[#ff3131] px-6 py-2.5 rounded-full font-bold text-sm hover:bg-gray-100 transition-colors"
              style={{ fontFamily: 'Fredoka, cursive' }}
            >
              Call: 02380 455007
            </a>
            <a 
              href="mailto:admin@gym-tots.co.uk"
              className="bg-white/20 text-white px-6 py-2.5 rounded-full font-bold text-sm hover:bg-white/30 transition-colors"
              style={{ fontFamily: 'Fredoka, cursive' }}
            >
              Email Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;
